// dashboardWidgetRegistryConfig/treasuryWidgetRegistry.config.ts
import type { DashboardWidgetRegistry } from "../DashboardWidgetRenderer";
import CashPosition from "../alternative-components/CashPosition";
import BalanceByAccount from "../alternative-components/BalanceByAccount";
import UpcomingObligations from "../alternative-components/UpcomingObligations";
import QuickActionsGrid from "../alternative-components/QuickActionsGrid";

// ------------ API Responses --------------------------------------------------------------------------------
export const TREASURY_BALANCE_OVERVIEW_MENU_IDS = new Set([61, 62, 63]);

export const TREASURY_WIDGET_REGISTRY: DashboardWidgetRegistry = {
  201: CashPosition, // Cash Position
  202: BalanceByAccount, // Balance By Account
  203: UpcomingObligations, // Upcoming Obligations
  204: QuickActionsGrid, // Quick Actions Grid
  // 67: StatementsWidget, // Statements
  // 68: ChequebookRequestWidget, // Chequebook Request
  // 69: BalanceConfirmationWidget, // Balance Confirmation
};
